module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main_apply main_container"
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "联合比对库资源",
      "name": "second"
    }
  }, [_c('el-form', {
    ref: "formData2",
    staticClass: "demo-ruleForm myForm",
    staticStyle: {
      "width": "70%",
      "margin": "auto"
    },
    attrs: {
      "model": _vm.formData2,
      "rules": _vm.rulesData2,
      "label-width": "150px"
    }
  }, [_c('div', {
    staticClass: "item_box"
  }, [_c('div', {
    staticClass: "title_sty"
  }, [_vm._v("申请人基本信息")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "申请人姓名:",
      "prop": "RequesterName"
    }
  }, [_c('el-input', {
    staticClass: "inpItem",
    model: {
      value: (_vm.formData2 && _vm.formData2.RequesterName),
      callback: function($$v) {
        _vm.$set(_vm.formData2 && _vm.formData2, "RequesterName", $$v)
      },
      expression: "formData2 && formData2.RequesterName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "申请人电话:",
      "prop": "RequesterPhoneNum"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "disabled"
    },
    model: {
      value: (_vm.formData2 && _vm.formData2.RequesterPhoneNum),
      callback: function($$v) {
        _vm.$set(_vm.formData2 && _vm.formData2, "RequesterPhoneNum", $$v)
      },
      expression: "formData2 && formData2.RequesterPhoneNum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所在单位:",
      "prop": "RequesterOrganisation"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formData2 && _vm.formData2.RequesterOrganisation),
      callback: function($$v) {
        _vm.$set(_vm.formData2 && _vm.formData2, "RequesterOrganisation", $$v)
      },
      expression: "formData2 && formData2.RequesterOrganisation"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "个人身份证明:",
      "required": "",
      "prop": "PersonIdentification"
    }
  }, [_vm._l(((_vm.formData2 && _vm.formData2.PersonIdentification)), function(item, i) {
    return _c('div', {
      key: item.FileGuid,
      staticClass: "input_box"
    }, [(_vm.ifFileNmae4) ? _c('div', {
      ref: 'indexImg_' + item.FileGuid,
      refInFor: true,
      attrs: {
        "id": 'indexImg_' + item.FileGuid
      }
    }, [_c('ul', {
      staticStyle: {
        "display": "inline-block"
      }
    }, [_c('li', {
      staticStyle: {
        "display": "inline-block"
      }
    }, [(_vm.ifFileNmae4) ? _c('span', {
      staticClass: "input_fileName",
      staticStyle: {
        "display": "inline-block",
        "color": "#606266"
      }
    }, [_vm._v("\n                                        " + _vm._s(item.FileName) + "\n                                    ")]) : _vm._e(), _vm._v(" "), _c('a', {
      staticClass: "view_a",
      attrs: {
        "target": "_blank",
        "id": "test"
      },
      on: {
        "click": function($event) {
          return _vm.showImgFn(item.FileGuid)
        }
      }
    }, [_vm._v("\n                                        查看\n                                        "), _c('img', {
      attrs: {
        "xss": "removed",
        "data-original": _vm.authImgUrl + '/api/Common/GetOriginalFile?BatchID=' + item.FileGuid
      }
    })])])]), _vm._v(" "), _c('a', {
      staticClass: "download_a",
      attrs: {
        "href": _vm.authImgUrl + '/api/Common/GetOriginalFile?BatchID=' + item.FileGuid,
        "download": "个人身份证明",
        "title": "下载",
        "target": "_blank"
      }
    }, [_vm._v("\n                                下载\n                            ")])]) : _vm._e()])
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.uploadAuth2(0)
      }
    }
  }, [_vm._v("点击上传")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "data-img": _vm.url,
      "type": "text",
      "size": "small"
    },
    on: {
      "click": _vm.$imgPreview
    }
  }, [_vm._v("模板")]), _vm._v(" "), _c('p', {
    staticClass: "tipText"
  }, [_vm._v("个人身份证明为作者本人身份证、学生证、教师证、护照等可证明本人身份的其中一项证件扫描件，支持gif、png、jpg格式\n                        ")])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "item_box"
  }, [_c('div', {
    staticClass: "title_sty"
  }, [_vm._v("待撤文章信息")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "题目名称:",
      "prop": "ArticleName"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formData2 && _vm.formData2.ArticleName),
      callback: function($$v) {
        _vm.$set(_vm.formData2 && _vm.formData2, "ArticleName", $$v)
      },
      expression: "formData2 && formData2.ArticleName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "作者:",
      "prop": "Author"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formData2 && _vm.formData2.Author),
      callback: function($$v) {
        _vm.$set(_vm.formData2 && _vm.formData2, "Author", $$v)
      },
      expression: "formData2 && formData2.Author"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "单位允许撤除证明:",
      "prop": "UnitIdentification"
    }
  }, [(_vm.ifFileNmae5) ? _c('div', {
    ref: 'indexImg_' + (_vm.formData2.UnitIdentification && _vm.formData2.UnitIdentification[0].FileGuid),
    attrs: {
      "id": 'indexImg_' + (_vm.formData2.UnitIdentification && _vm.formData2.UnitIdentification[0].FileGuid)
    }
  }, [_c('ul', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('li', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [(_vm.ifFileNmae5) ? _c('span', {
    staticClass: "input_fileName",
    staticStyle: {
      "display": "inline-block",
      "color": "#606266"
    }
  }, [_vm._v(_vm._s(_vm.formData2.UnitIdentification && _vm.formData2.UnitIdentification[0].FileName))]) : _vm._e(), _c('a', {
    staticClass: "view_a",
    attrs: {
      "target": "_blank",
      "id": "test"
    },
    on: {
      "click": function($event) {
        return _vm.showImgFn(_vm.formData2.UnitIdentification && _vm.formData2.UnitIdentification[0].FileGuid)
      }
    }
  }, [_vm._v("查看"), _c('img', {
    attrs: {
      "xss": "removed",
      "data-original": _vm.authImgUrl + '/api/Common/GetOriginalFile?BatchID=' + (_vm.formData2.UnitIdentification && _vm.formData2.UnitIdentification[0].FileGuid)
    }
  })])])]), _vm._v(" "), _c('a', {
    staticClass: "download_a",
    attrs: {
      "href": _vm.authImgUrl + '/api/Common/GetOriginalFile?BatchID=' + (_vm.formData2.UnitIdentification && _vm.formData2.UnitIdentification[0].FileGuid),
      "download": "单位允许撤除证明模板",
      "title": "下载",
      "target": "_blank"
    }
  }, [_vm._v("\n                            下载\n                        ")])]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.uploadAuth2(1)
      }
    }
  }, [_vm._v("点击上传")]), _vm._v(" "), _c('span', {
    staticClass: "model_span",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c('a', {
    staticClass: "download_a",
    attrs: {
      "href": _vm.authImgUrl + '/api/Common/GetTemplateFile',
      "download": "知网撤除比对申请表",
      "title": "知网撤除比对申请表",
      "target": "_blank"
    }
  }, [_vm._v("\n                            模板\n                        ")])]), _vm._v(" "), _c('p', {
    staticClass: "tipText"
  }, [_vm._v("证明必须加盖检测单位管理部门公章，支持gif、png、jpg格式")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "检测报告单:",
      "prop": "CheckReport"
    }
  }, [(_vm.ifFileNmae6) ? _c('div', {
    ref: 'indexImg_' + (_vm.formData2.CheckReport && _vm.formData2.CheckReport[0].FileGuid),
    attrs: {
      "id": 'indexImg_' + (_vm.formData2.CheckReport && _vm.formData2.CheckReport[0].FileGuid)
    }
  }, [_c('ul', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('li', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [(_vm.ifFileNmae6) ? _c('span', {
    staticClass: "input_fileName",
    staticStyle: {
      "display": "inline-block",
      "color": "#606266"
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.formData2.CheckReport && _vm.formData2.CheckReport[0].FileName) + "\n                                ")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "view_a",
    attrs: {
      "target": "_blank",
      "id": "test"
    },
    on: {
      "click": function($event) {
        _vm.showImgFn((_vm.formData2.CheckReport && _vm.formData2.CheckReport[0].FileGuid), 'pdf')
      }
    }
  }, [_vm._v("\n                                    查看\n                                    "), _c('img', {
    attrs: {
      "xss": "removed",
      "data-original": _vm.authImgUrl + '/api/Common/GetOriginalFile?BatchID=' + (_vm.formData2.CheckReport && _vm.formData2.CheckReport[0].FileGuid)
    }
  })])])]), _vm._v(" "), _c('a', {
    staticClass: "download_a",
    attrs: {
      "href": _vm.authImgUrl + '/api/Common/GetOriginalFile?BatchID=' + (_vm.formData2.CheckReport && _vm.formData2.CheckReport[0].FileGuid),
      "download": "检测报告单",
      "title": "下载",
      "target": "_blank"
    }
  }, [_vm._v("\n                            下载\n                        ")])]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.uploadAuth2(2)
      }
    }
  }, [_vm._v("点击上传")]), _vm._v(" "), _c('p', {
    staticClass: "tipText"
  }, [_vm._v("请提供最近一次完整的检测报告单，支持pdf格式")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "待撤文章位置:",
      "prop": "ArticleLocation"
    }
  }, [(_vm.ifFileNmae7) ? _c('div', {
    ref: 'indexImg_' + (_vm.formData2.ArticleLocation && _vm.formData2.ArticleLocation[0].FileGuid),
    attrs: {
      "id": 'indexImg_' + (_vm.formData2.ArticleLocation && _vm.formData2.ArticleLocation[0].FileGuid)
    }
  }, [_c('ul', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('li', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [(_vm.ifFileNmae7) ? _c('span', {
    staticClass: "input_fileName",
    staticStyle: {
      "display": "inline-block",
      "color": "#606266"
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.formData2.ArticleLocation && _vm.formData2.ArticleLocation[0].FileName) + "\n                                ")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "view_a",
    attrs: {
      "target": "_blank",
      "id": "test"
    },
    on: {
      "click": function($event) {
        return _vm.showImgFn(_vm.formData2.ArticleLocation && _vm.formData2.ArticleLocation[0].FileGuid)
      }
    }
  }, [_vm._v("\n                                    查看\n                                    "), _c('img', {
    attrs: {
      "xss": "removed",
      "data-original": _vm.authImgUrl + '/api/Common/GetOriginalFile?BatchID=' + (_vm.formData2.ArticleLocation && _vm.formData2.ArticleLocation[0].FileGuid)
    }
  })])])]), _vm._v(" "), _c('a', {
    staticClass: "download_a",
    attrs: {
      "href": _vm.authImgUrl + '/api/Common/GetOriginalFile?BatchID=' + (_vm.formData2.ArticleLocation && _vm.formData2.ArticleLocation[0].FileGuid),
      "download": "待撤文章位置",
      "title": "下载",
      "target": "_blank"
    }
  }, [_vm._v("\n                            下载\n                        ")])]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.uploadAuth2(3)
      }
    }
  }, [_vm._v("点击上传")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "data-img": _vm.url2,
      "type": "text",
      "size": "small"
    },
    on: {
      "click": _vm.$imgPreview
    }
  }, [_vm._v("示例")]), _vm._v(" "), _c('p', {
    staticClass: "tipText"
  }, [_vm._v("请将待撤文章在检测报告单中的具体位置进行标注并上传标注后的附件，支持gif、png、jpg格式")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "subBtn_box"
  }, [_c('el-form-item', {
    staticClass: "btn_box"
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.regLoading),
      expression: "regLoading"
    }],
    staticClass: "submit_btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitInfo2('formData2')
      }
    }
  }, [_vm._v("确定")])], 1)], 1)]), _vm._v(" "), _c('global-uploaderTwo')], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "互联网资源",
      "name": "first"
    }
  }, [_c('el-form', {
    ref: "formData1",
    staticClass: "demo-ruleForm myForm",
    staticStyle: {
      "width": "70%",
      "margin": "auto"
    },
    attrs: {
      "model": _vm.formData1,
      "rules": _vm.rulesData1,
      "label-width": "150px"
    }
  }, [_c('div', {
    staticClass: "item_box"
  }, [_c('div', {
    staticClass: "title_sty"
  }, [_vm._v("申请人基本信息")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "申请人姓名:",
      "prop": "RequesterName"
    }
  }, [_c('el-input', {
    staticClass: "inpItem",
    model: {
      value: (_vm.formData1 && _vm.formData1.RequesterName),
      callback: function($$v) {
        _vm.$set(_vm.formData1 && _vm.formData1, "RequesterName", $$v)
      },
      expression: "formData1 && formData1.RequesterName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "申请人电话:",
      "prop": "RequesterPhoneNum"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "disabled"
    },
    model: {
      value: (_vm.formData1 && _vm.formData1.RequesterPhoneNum),
      callback: function($$v) {
        _vm.$set(_vm.formData1 && _vm.formData1, "RequesterPhoneNum", $$v)
      },
      expression: "formData1 && formData1.RequesterPhoneNum"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "item_box"
  }, [_c('div', {
    staticClass: "title_sty"
  }, [_vm._v("待撤文章信息")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "题目名称:",
      "prop": "ArticleName"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formData1 && _vm.formData1.ArticleName),
      callback: function($$v) {
        _vm.$set(_vm.formData1 && _vm.formData1, "ArticleName", $$v)
      },
      expression: "formData1 && formData1.ArticleName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "作者:",
      "prop": "Author"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formData1 && _vm.formData1.Author),
      callback: function($$v) {
        _vm.$set(_vm.formData1 && _vm.formData1, "Author", $$v)
      },
      expression: "formData1 && formData1.Author"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "检测报告单:",
      "prop": "CheckReport"
    }
  }, [(_vm.ifFileNmae2) ? _c('div', {
    ref: 'indexImg_' + (_vm.formData1.CheckReport[0] && _vm.formData1.CheckReport[0].FileGuid),
    attrs: {
      "id": 'indexImg_' + (_vm.formData1.CheckReport[0] && _vm.formData1.CheckReport[0].FileGuid)
    }
  }, [_c('ul', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('li', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [(_vm.ifFileNmae2) ? _c('span', {
    staticClass: "input_fileName",
    staticStyle: {
      "display": "inline-block",
      "color": "#606266"
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.formData1.CheckReport[0] && _vm.formData1.CheckReport[0].FileName) + "\n                                ")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "view_a",
    attrs: {
      "target": "_blank",
      "id": "test"
    },
    on: {
      "click": function($event) {
        return _vm.showImgFn(_vm.formData1.CheckReport[0] && _vm.formData1.CheckReport[0].FileGuid, 'pdf')
      }
    }
  }, [_vm._v("\n                                    查看\n                                "), _c('img', {
    attrs: {
      "xss": "removed",
      "data-original": _vm.authImgUrl + '/api/Common/GetOriginalFile?BatchID=' + (_vm.formData1.CheckReport[0] && _vm.formData1.CheckReport[0].FileGuid)
    }
  })])])]), _vm._v(" "), _c('a', {
    staticClass: "download_a",
    attrs: {
      "href": _vm.authImgUrl + '/api/Common/GetOriginalFile?BatchID=' + (_vm.formData1.CheckReport[0] && _vm.formData1.CheckReport[0].FileGuid),
      "download": "检测报告单",
      "title": "下载",
      "target": "_blank"
    }
  }, [_vm._v("\n                            下载\n                        ")])]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.uploadAuth1(2)
      }
    }
  }, [_vm._v("点击上传")]), _vm._v(" "), _c('p', {
    staticClass: "tipText"
  }, [_vm._v("请提供最近一次完整的检测报告单，支持pdf格式")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "待撤文章位置:",
      "prop": "ArticleLocation"
    }
  }, [(_vm.ifFileNmae3) ? _c('div', {
    ref: 'indexImg_' + (_vm.formData1.ArticleLocation[0] && _vm.formData1.ArticleLocation[0].FileGuid),
    attrs: {
      "id": 'indexImg_' + (_vm.formData1.ArticleLocation[0] && _vm.formData1.ArticleLocation[0].FileGuid)
    }
  }, [_c('ul', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('li', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [(_vm.ifFileNmae3) ? _c('span', {
    staticClass: "input_fileName",
    staticStyle: {
      "display": "inline-block",
      "color": "#606266"
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.formData1.ArticleLocation[0] && _vm.formData1.ArticleLocation[0].FileName) + "\n                                ")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "view_a",
    attrs: {
      "target": "_blank",
      "id": "test"
    },
    on: {
      "click": function($event) {
        return _vm.showImgFn(_vm.formData1.ArticleLocation[0] && _vm.formData1.ArticleLocation[0].FileGuid)
      }
    }
  }, [_vm._v("\n                                    查看\n                                    "), _c('img', {
    attrs: {
      "xss": "removed",
      "data-original": _vm.authImgUrl + '/api/Common/GetOriginalFile?BatchID=' + (_vm.formData1.ArticleLocation[0] && _vm.formData1.ArticleLocation[0].FileGuid)
    }
  })])])]), _vm._v(" "), _c('a', {
    staticClass: "download_a",
    attrs: {
      "href": _vm.authImgUrl + '/api/Common/GetOriginalFile?BatchID=' + (_vm.formData1.ArticleLocation[0] && _vm.formData1.ArticleLocation[0].FileGuid),
      "download": "待撤文章位置",
      "title": "下载",
      "target": "_blank"
    }
  }, [_vm._v("\n                            下载\n                        ")])]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.uploadAuth1(3)
      }
    }
  }, [_vm._v("点击上传")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "data-img": _vm.url1,
      "type": "text",
      "size": "small"
    },
    on: {
      "click": _vm.$imgPreview
    }
  }, [_vm._v("示例")]), _vm._v(" "), _c('p', {
    staticClass: "tipText"
  }, [_vm._v("请将待撤文章在检测报告单中的具体位置进行标注并上传标注后的附件，支持gif、png、jpg格式\n                        ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "subBtn_box"
  }, [_c('el-form-item', {
    staticClass: "btn_box"
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.regLoading),
      expression: "regLoading"
    }],
    staticClass: "submit_btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitInfo1('formData1')
      }
    }
  }, [_vm._v("确定")])], 1)], 1)]), _vm._v(" "), _c('global-uploader')], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9d741078"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/userPages/applyCancel/applyIndex.vue
// module id = 1202
// module chunks = 1